import * as yup from 'yup';
import { ObjectSchema } from 'yup';
import { TFunction } from 'i18next';
import {
  LanguageCode,
  languageMap,
  LocalizedLanguageFormData,
} from '../../../../app/data/models/common/localizedLanguage';
import { MealItemCustomizationFormData } from '../../../../app/data/models/mealItems/mealItemCustomizationFormData';

export const mealItemCustomizationValidationSchema = (
  t: TFunction,
  languageCodes: LanguageCode[]
): ObjectSchema<MealItemCustomizationFormData> => {
  const requiredLocalizedStringSchema: ObjectSchema<LocalizedLanguageFormData> =
    yup
      .object()
      .shape(
        languageCodes.reduce(
          (acc, code) => {
            acc[code] = yup.string().required(
              t(
                'customization.validation.customer-instructions-field-required',
                {
                  field: t(languageMap[code]),
                }
              )
            );
            return acc;
          },
          {} as Record<LanguageCode, yup.StringSchema<string>>
        )
      )
      .required()
      .defined();

  // Optional localized string schema for internalNotes
  const optionalLocalizedStringSchema: ObjectSchema<LocalizedLanguageFormData> =
    yup
      .object()
      .shape(
        languageCodes.reduce(
          (acc, code) => {
            acc[code] = yup.string();
            return acc;
          },
          {} as Record<LanguageCode, yup.StringSchema<string>>
        )
      )
      .notRequired();

  return yup
    .object({
      customerInstructions: requiredLocalizedStringSchema,
      internalNotes: optionalLocalizedStringSchema,
    })
    .required()
    .defined() as ObjectSchema<MealItemCustomizationFormData>;
};

export const mealItemCustomizationOptionValidationSchema = (
  t: TFunction,
  languageCodes: LanguageCode[]
) => {
  const localizedStringShape = languageCodes.reduce(
    (acc, code) => ({
      ...acc,
      [code]: yup.string().required(
        t('customization-option.validation.name-required', {
          field: t(languageMap[code]),
        })
      ),
    }),
    {}
  );

  return yup.object().shape({
    id: yup.string().optional(),
    names: yup.object().shape(localizedStringShape),
    price: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === '' ? null : value
      )
      .required(t('customization-option.validation.price-required'))
      .min(0, t('customization-option.validation.price-min', { value: 0 })),
    isAvailable: yup.boolean().required(),
  });
};
